/** React libraries */
import React, { useEffect } from "react";
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  useNavigate,
} from "react-router-dom";
import {
  appInsights,
  reactPlugin,
  browserHistory,
} from "../utils/appInsights";
import { withAITracking } from "@microsoft/applicationinsights-react-js";
import { AppInsightsContext } from "@microsoft/applicationinsights-react-js";
import { logout } from './../services/auth.api';

/**  Pages */
import Dashboard from "../pages/Dashboard/Dashboard";
import ErrorPage from "../pages/ErrorPage/ErrorPage";
import AuthCallback from "../pages/AuthCallBack/AuthCallback";
import LogoRequest from "../pages/LogoRequest/LogoRequest";
import ManageLogoPortalUser from "../pages/Manage-Logo-Portal-User/ManageLogoPortalUser";
import Certificate from "../pages/Certificates/Certificate";

/** Custom components */
import Sidebar from "../components/Sidenav/sidenav.components";

const DashboardWithTracking = withAITracking(reactPlugin, Dashboard);

const ProtectedRoute: React.FC<{ children: JSX.Element }> = ({ children }) => {
  const isAuthenticated = !!localStorage.getItem("access_token");
  const navigate = useNavigate();

  useEffect(() => {
    if (!isAuthenticated) {
       logout();
    }
  }, [isAuthenticated, navigate]);

  if (isAuthenticated) {
    return children;
  }
  return null;
};

export const AppRouter: React.FC = () => {
  return (
      <div className="app-container">
        <Sidebar />
        <div className="main-content">
          <Routes>
            <Route path="/auth-callback" element={<AuthCallback />} />
            <Route path="/" element={<Navigate to="/certificates" replace />} />
            <Route
              path="/dashboard/:certificateId"
              element={
                <ProtectedRoute>
                  <DashboardWithTracking />
                </ProtectedRoute>
              }
            />
            <Route
              path="/certificates"
              element={
                <ProtectedRoute>
                  <Certificate />
                </ProtectedRoute>
              }
            />
            <Route
              path="/manageUser"
              element={
                <ProtectedRoute>
                  <ManageLogoPortalUser />
                </ProtectedRoute>
              }
            />
            <Route
              path="/setting"
              element={
                <ProtectedRoute>
                  <ErrorPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/logoRequest/:certificateId/:type"
              element={
                <ProtectedRoute>
                  <LogoRequest />
                </ProtectedRoute>
              }
            />
             <Route
              path="/logoRequest/:certificateId/:requestId/:type"
              element={
                <ProtectedRoute>
                  <LogoRequest />
                </ProtectedRoute>
              }
            />
            <Route path="*" element={<Navigate to="/ErrorPage" replace />} />
            <Route path="/ErrorPage" element={<ErrorPage />} />
          </Routes>
        </div>
      </div>
  );
};
